export const HASH = {
  verifyReco: '#verifyReco' as const,
  editForm: '#edit' as const,
  verifyId: '#verifyId' as const,
  terms: '#terms' as const,
  privacy: '#privacy' as const,
  openTransactionDetails: '#details' as const,
  applicantIDs: '#ids' as const
};
